import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

var _types$SET_DEFAULT_OR;

import { toggleFacetInFilterBy, addUniqFacetInFilterBy } from '~/helpers/filter-helper';
import * as types from './types';
export default (_types$SET_DEFAULT_OR = {}, _defineProperty(_types$SET_DEFAULT_OR, types.SET_DEFAULT_ORDERBY, function (state, payload) {
  var currentState = state;
  currentState.orderBy = payload;
}), _defineProperty(_types$SET_DEFAULT_OR, types.SET_DEFAULT_SORTBY, function (state, payload) {
  var currentState = state;
  currentState.sortBy = payload;
}), _defineProperty(_types$SET_DEFAULT_OR, types.SET_DEFAULT_FILTERBY, function (state, payload) {
  var currentState = state;
  currentState.filterBy = payload;
}), _defineProperty(_types$SET_DEFAULT_OR, types.SORT_BY, function (state, payload) {
  var currentState = state;
  currentState.sortBy = payload;
}), _defineProperty(_types$SET_DEFAULT_OR, types.ORDER_BY, function (state, payload) {
  var currentState = state;
  currentState.orderBy = payload;
}), _defineProperty(_types$SET_DEFAULT_OR, types.FILTER_BY, function (state, _ref) {
  var filter = _ref.filter,
      facet = _ref.facet,
      _ref$uniq = _ref.uniq,
      uniq = _ref$uniq === void 0 ? false : _ref$uniq;
  var currentState = state;
  var transform = uniq ? addUniqFacetInFilterBy : toggleFacetInFilterBy;
  currentState.filterBy = transform(_objectSpread({}, currentState.filterBy), filter, facet);
}), _defineProperty(_types$SET_DEFAULT_OR, types.RESET_FILTERS, function (state) {
  var currentState = state;
  currentState.filterBy = null;
}), _defineProperty(_types$SET_DEFAULT_OR, types.RESET_PAGINATION, function (state) {
  var currentState = state;
  currentState.previousPage = 1;
  currentState.nextPage = 1;
}), _defineProperty(_types$SET_DEFAULT_OR, types.SET_NEXT_PAGE, function (state, payload) {
  var currentState = state;
  currentState.nextPage = payload;
}), _defineProperty(_types$SET_DEFAULT_OR, types.SET_PREVIOUS_PAGE, function (state, payload) {
  var currentState = state;
  currentState.previousPage = payload;
}), _types$SET_DEFAULT_OR);